module.exports = __webpack_public_path__ + "static/media/accolades.f12afb1a.jpg";